const EmergencyBanner = () => {
  return (
    <section className="bg-[#1A2F4A] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          {/* Left - Text */}
          <div className="flex items-center space-x-4">
            <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-alarm-warning-line text-4xl text-white"></i>
            </div>
            <div>
              <h3 className="text-3xl font-bold text-white mb-1">Need Emergency Help?</h3>
              <p className="text-white/80">We're available 24/7 for urgent plumbing issues</p>
            </div>
          </div>

          {/* Right - Contact */}
          <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6">
            <div className="text-center sm:text-right">
              <a href="tel:01943123456" className="text-4xl font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                01943 123 456
              </a>
              <p className="text-white/80 text-sm mt-1">24/7 Available</p>
            </div>
            <a
              href="tel:01943123456"
              className="bg-white text-[#1A2F4A] px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyBanner;